/**
 * Cart summary toggle.
 * Owns the cart drawer summary disclosure and works after cart drawer section refreshes.
 */
(function () {
  function isMobileSummary() {
    return window.matchMedia('(max-width: 600px)').matches;
  }

  function getSummary(button) {
    if (!button) return null;
    var summaryId = button.getAttribute('aria-controls');
    var root = button.closest('.cart-drawer__footer') || document;
    if (!summaryId) return null;
    return document.getElementById(summaryId) || root.querySelector('[id="' + summaryId.replace(/"/g, '\"') + '"]');
  }

  function setSummaryState(button, expanded) {
    var summary = getSummary(button);
    if (!button || !summary) return;

    if (!isMobileSummary()) {
      button.setAttribute('aria-expanded', 'true');
      button.classList.remove('is-expanded');
      summary.hidden = false;
      summary.classList.add('is-expanded');
      return;
    }

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.classList.toggle('is-expanded', expanded);
    summary.hidden = !expanded;
    summary.classList.toggle('is-expanded', expanded);
  }

  function syncAll() {
    document.querySelectorAll('.cart-summary-toggle').forEach(function (button) {
      setSummaryState(button, button.getAttribute('aria-expanded') === 'true');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.cart-summary-toggle');
    if (!button) return;
    event.preventDefault();
    setSummaryState(button, button.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('resize', syncAll);
})();
